import moment from "moment";

export const EXPORT_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const EXPORT_DATE_FORMAT = "YYYY-MM-DD";
export const MONTH_FORMAT = "MMMM YYYY";

export const CURRENT_CALENDAR_MONTH_DISPLAY = moment()
  .utc()
  .format(MONTH_FORMAT);
export const PREVIOUS_CALENDAR_MONTH_DISPLAY = moment()
  .utc()
  .subtract(1, "month")
  .format(MONTH_FORMAT);

export const formatDateToLocale = (date: string, addTime?: boolean) => {
  const currentDate = moment(date).utc();

  if (currentDate.hour() === 0) {
    currentDate.add(12, "h");
  }

  const isCurrentYear = currentDate.year() === moment().year();

  const formattedDate = currentDate.toDate().toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: !isCurrentYear ? "numeric" : undefined,
    hour: addTime ? "2-digit" : undefined,
    minute: addTime ? "2-digit" : undefined,
    hour12: false
  });

  if (!isCurrentYear && !addTime) return formattedDate.replace(",", "");

  return formattedDate;
};

export const locale = Intl.DateTimeFormat().resolvedOptions().locale;
